/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsItemsProductsCtrl
 * @description A report with sales grouped by Pos Item
 */
angular.module('mercury.modules.reports.items')
.controller('ReportsItemGroupsCtrl', ["$filter", "PosItemGroups", "ReportPosStaff", "reporttime", "$scope", "$stateParams", "title", "$q", function($filter, PosItemGroups, ReportPosStaff, reporttime, $scope, $stateParams, title, $q) {
  $scope.groupCols = [
    {label: 'Group', type: 'string', key: 'itemGroupName'},
    {label: 'Sales', type: 'number', key: 'orders', filter: 'currency'}
  ];

  if ($stateParams.staffId && $stateParams.staffName) {
    $scope.loading = $q.all({
      groupSales: ReportPosStaff.getItemGroupSalesForStaff(reporttime.start(), reporttime.end(), $stateParams.staffId),
      groupOrders: ReportPosStaff.getItemGroupsForStaff(reporttime.start(), reporttime.end(), $stateParams.staffId)
    });
    title.set('Product Groups Report for ' + $stateParams.staffName);
  } else {
    $scope.loading = $q.all({
      groupSales: PosItemGroups.getSales(reporttime.start(), reporttime.end()),
      groupOrders: PosItemGroups.getOrders(reporttime.start(), reporttime.end())
    });
    title.set('Product Groups Report');
  }

  $scope.loading.then(function(results) {
    angular.forEach(results.groupOrders, function(orderGroup) {
      var foundMatch = false;
      angular.forEach(results.groupSales, function(salesGroup) {
        if (salesGroup.itemGroupIdentifier == orderGroup.itemGroupIdentifier) {
          salesGroup.orders = orderGroup.amount;
          salesGroup.orderQty = orderGroup.quantity;
          foundMatch = true;
        }
      });

      // It is possible that an item was ordered, but not sold in the report period
      if (!foundMatch) {
        results.groupSales.push({
          itemGroupIdentifier: orderGroup.itemGroupIdentifier,
          itemGroupName: orderGroup.itemGroupName,
          quantity: 0,
          invoices: 0,
          orders: orderGroup.amount,
          orderQty: orderGroup.quantity
        });
      }
    });

    $scope.groups = results.groupSales;
    $scope.totalOrders = $filter('sumof')($scope.groups, 'orders');
  });
}]);
